import React from "react";
import * as FaIcons from "react-icons/fa";

import raceCategoryList from "../../../data/raceCategoryList";

const R6Ethnicity = ({ formData, onFormDataChange, validationCheck }) => {
  const { firstName, isStudentHispanicOrLatino, primaryRaceCategory } =
    formData;
  return (
    <>
      {/* Ethnicity */}
      <div className="sub-form">
        <h3>Ethnicity</h3>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Is {firstName === "" ? "the Student" : firstName} Hispanic or
              Latino?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  isStudentHispanicOrLatino["yes"] ||
                  isStudentHispanicOrLatino["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={isStudentHispanicOrLatino["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="isStudentHispanicOrLatino"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={isStudentHispanicOrLatino["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="isStudentHispanicOrLatino"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the Student" : firstName}'s Primary
              Race Category?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="primaryRaceCategory"
            value={primaryRaceCategory}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(primaryRaceCategory !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {raceCategoryList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>
      </div>
    </>
  );
};

export default R6Ethnicity;
